<template lang="pug">
.reservation-edit-text-modal
  b-modal(v-model="_modalShow" size="md" @ok="ok" @cancel="cancel" title="面会場所を編集します" no-close-on-backdrop no-close-on-esc)
    .register-body
      FormInputSelect(
        key-name="面会場所"
        required
        name="location"
        v-model="location"
        :options="locationOptions"
        :validation-rules="{ required: true }"
        :styles="{ 'max-width': '340px' }")

    .footer(slot="modal-footer" slot-scope="{ ok, cancel }" style="width:100%;")
      ValidationAlert(v-model="_showValidationAlert")
      .buttons.d-flex.justify-content-end
        button.btn.modal-ok-btn(type="button" @click="ok()") OK
        button.btn.modal-cancel-btn(type="button" @click="cancel()") キャンセル
</template>

<script lang="ts">
import { Component, Inject, Prop, Vue } from "vue-property-decorator";
import { userStore } from "@/store/store";

import ReservationSettingsService, { ReservationSettingsGetModel } from "@/commons/services/ReservationSettings";

import ValidationAlert from "@/pc/basics/ValidationAlertByValidator.vue";
import FormInputSelect from "@/pc/components/forms/FormInputSelect.vue";

/**
 * ### 面会場所編集モーダル
 */
@Component({
  components: {
    ValidationAlert,
    FormInputSelect
  },
  $_veeValidate: { validator: "new" }
})
export default class EditLocationModal extends Vue {
  /** 訪問面会設定サービス */
  @Inject("ReservationSettingsService") reservationSettingsService!: ReservationSettingsService;

  @Prop()
  value!: boolean;

  /** バリデーションアラート表示可否 */
  showValidationAlert: boolean = false;

  /** 面会場所 */
  location: string = "";
  /** 面会場所セレクトボックス用項目 */
  locationOptions: Array<{ value: number | string; label: string }> = [];

  get _modalShow(): boolean {
    return this.value;
  }

  set _modalShow(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }

  get _showValidationAlert(): boolean {
    return this.showValidationAlert;
  }

  set _showValidationAlert(newValue: boolean) {
    this.showValidationAlert = false;
    return;
  }

  /**
   * ### vue lifecycle created
   */
  public async mounted(): Promise<void> {
    await this.createView();
    return;
  }

  public async createView(): Promise<void> {
    const setting: ReservationSettingsGetModel = await this.getReservationSetting();
    if (setting.useLocation) {
      const options: Array<{ value: number | string; label: string }> = [];
      for (const option of setting.locationOptions) {
        options.push({
          label: option.name,
          value: option.name
        });
      }
      this.locationOptions = options;
    }
    return;
  }

  public async getReservationSetting(): Promise<ReservationSettingsGetModel> {
    const response: ReservationSettingsGetModel = await this.reservationSettingsService.get(userStore);
    return response;
  }

  async ok(modalEvent: any): Promise<void> {
    modalEvent.preventDefault();
    const validationResult: boolean = await this.$validator.validateAll();
    if (validationResult) {
      this.showValidationAlert = false;
      this.$emit("ok", this.location);
    } else {
      this.showValidationAlert = true;
    }
    return;
  }

  cancel(): void {
    this.location = "";
    this.$emit("cancel");
    return;
  }
}
</script>
